import {Grid, Statistic} from '@primer/react-brand/esm'
import {renderWithoutParagraphs} from '../../../../utils'
import type {TextItem} from '../../../../types'

type Props = {
  stats?: TextItem[]
}

export function OutroStats({stats}: Props) {
  if (!stats?.length) return null

  return (
    <Grid>
      {stats.map(stat => (
        <Grid.Column key={stat.sys.id} span={{medium: 4}}>
          <Statistic>
            <Statistic.Heading weight="normal" size="800" style={{color: 'var(--brand-color-text-emphasized)'}}>
              {renderWithoutParagraphs(stat.fields.heading)}
            </Statistic.Heading>
            <Statistic.Description>{renderWithoutParagraphs(stat.fields.description)}</Statistic.Description>
          </Statistic>
        </Grid.Column>
      ))}
    </Grid>
  )
}
